var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"behavior-chart-container"},[_vm._m(0),_c('jr-echarts',{ref:"echartsRef",attrs:{"options":_vm.chartOptions,"height":_vm.height,"width":_vm.width}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-header"},[_c('div',{staticClass:"period-selector"},[_c('span',[_vm._v("统计周期：近半年")])])])
}]

export { render, staticRenderFns }